var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"layout"}},[_c(_vm.layoutName,{tag:"component",staticClass:"layout"})],1),_c('dialogs-wrapper',{attrs:{"tag":"div","id":'modal_popup'}}),_c('dialogs-wrapper',{attrs:{"tag":"div","name":"error","id":'modal_error_popup'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }